import { apiClient } from './api'

// ── Types ──────────────────────────────────────────────────

export interface DashboardIndicators {
  totalStructures: number;
  connectedLast24h: number;
  totalBeds: number;
  occupiedBeds: number;
  occupancyRate: number;
  orientationsToday: number;
  stockAlerts: number;
}

export type TensionLevel = 'LOW' | 'MODERATE' | 'HIGH' | 'CRITICAL';

export interface RegionSummary {
  regionId: string;
  name: string;
  structureCount: number;
  occupancyRate: number;
  tensionLevel: TensionLevel;
  orientationsToday: number;
  stockAlerts: number;
}

export interface BedInfo {
  total: number;
  occupied: number;
  available: number;
}

export interface StockInfo {
  byGroup: Record<string, number>;
  criticalBelow: string[];
}

export interface StructureDetail {
  id: string;
  name: string;
  identifierCode: string;
  latitude: number;
  longitude: number;
  freshness: string;
  beds: BedInfo;
  orientationsToday: number;
  stocks: StockInfo;
}

export interface RecentOrientationEntry {
  orientationRef: string;
  motif: string;
  gravite: string;
  status: string;
  chosenStructureName: string;
  createdAt: string;
}

export interface NationalDashboard {
  generatedAt: string;
  indicators: DashboardIndicators;
  regions: RegionSummary[];
  recentOrientations: RecentOrientationEntry[];
}

export interface RegionDashboard {
  regionId: string;
  name: string;
  structures: StructureDetail[];
}

// ── API Calls ──────────────────────────────────────────────

export const dashboardApi = {
  getNational: async (): Promise<NationalDashboard> => {
    const res = await apiClient.get<NationalDashboard>('/api/v1/dashboard/national')
    return res.data
  },

  getRegion: async (regionId: string): Promise<RegionDashboard> => {
    const res = await apiClient.get<RegionDashboard>(`/api/v1/dashboard/region/${regionId}`)
    return res.data
  },
}
